<template>
  <div class="navbar" :class="{ 'zh-only-site': isZhOnlySite }">
    <div class="logo-container">
      <img class="logo" src="../../../assets/images/xf/logo.png" v-if="siteId === siteEnum.XF1 || siteId === Number(siteEnum.XF1)"> <!--XF-->
      <img class="logo" src="../../../assets/images/dy/logo.png" v-if="siteId === siteEnum.DY2 || siteId === Number(siteEnum.DY2)"> <!--DY-->
      <img class="logo" src="../../../assets/images/home/logo_w_text.png" v-if="siteId === siteEnum.LH1 || siteId === Number(siteEnum.LH1)"> <!--LH-->
      <img class="logo" src="../../../assets/images/ind/logo.png" v-if="siteId === siteEnum.IND || siteId === Number(siteEnum.IND)"> <!--LH-->
      <img class="logo" src="../../../assets/images/br2/br2-logo-square.png" v-if="siteId === siteEnum.BR2 || siteId === Number(siteEnum.BR2)"> <!--BR2-->
      <img class="logo" src="../../../assets/images/ak2/ak2-logo-square.png" v-if="siteId === siteEnum.AK2 || siteId === Number(siteEnum.AK2)"> <!--AK2-->
      <img class="logo" src="../../../assets/images/br2/lk6-logo.png" v-if="siteId === siteEnum.LK6 || siteId === Number(siteEnum.LK6)"> <!--LK6-->
      <img class="logo" src="../../../assets/images/ph2/logo.jpg" v-if="siteId === siteEnum.PH2 || siteId === Number(siteEnum.PH2)"> <!--PH2-->
    </div>
    <div class="right-menu">
      <el-select v-if="!isZhOnlySite" class="lang-container right-menu-item" placeholder="" v-model="languageVal" @change="handleLanguage">
        <el-option key="1" value="en">en</el-option>
        <el-option key="2" value="zh">zh</el-option>
        <el-option key="3" value="th">th</el-option>
        <el-option key="4" value="vi">vi</el-option>
        <el-option key="5" value="kr">kr</el-option>
        <el-option key="6" value="pt">pt</el-option>
        <el-option key="7" value="ph">ph</el-option>
      </el-select>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
          <span style="display:inline-block;"> {{ name }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item>
              <span style="display:block;"> {{ name }}</span>
            </el-dropdown-item>
            <ForgetPasswordModal :requireOld="true" @submit="changePassword">
              <el-dropdown-item divided>
                {{ $t('common.changePassword') }}
              </el-dropdown-item>
            </ForgetPasswordModal>
            <el-dropdown-item @click="logout">
              <span style="display:block;">
                {{ $t('common.logout') }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <svg-icon :class="'logout-btn-container'" :icon-class="'logout'" :title="$t('common.logout')" @click="logout" />
    </div>
  </div>
</template>

<script>
import ForgetPasswordModal from "@/components/forgetpassword-modal/Index.vue";

import { siteEnum } from "@/consts/SiteEnum"
import { computed, reactive, toRefs, onMounted } from "vue";
import { useStore } from "@/store";
import { AppActionTypes } from "@/store/modules/app/action-types";
import { UserActionTypes } from "@/store/modules/user/action-types";
import { storeToRefs } from "pinia";
import { i18nStore } from "@/store/language";
import { useRouter } from 'vue-router';

export default {
  components: {
    ForgetPasswordModal
  },
  setup() {
    onMounted(() => {
      if (isZhOnlySite.value) {
        languageVal.value = 'zh';
      }
      handleLanguage();
    })
    const router = useRouter();
    const store = useStore();
    const sidebar = computed(() => {
      return store.state.app.sidebar;
    });
    const device = computed(() => {
      return store.state.app.device.toString();
    });
    const avatar = computed(() => {
      return store.state.user.avatar;
    });
    const name = computed(() => {
      return store.state.user.name;
    });
    const siteId = computed(() => {
      return store.state.user.siteId
    })
    // XF1 / DY2 / LH1 are Chinese-only: no language switcher, locale fixed to zh
    const isZhOnlySite = computed(() => {
      return [siteEnum.XF1, siteEnum.DY2, siteEnum.LH1].map(Number).includes(Number(siteId.value))
    })
    const state = reactive({
      toggleSideBar: () => {
        store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false);
      },
      logout: async () => {
        const siteIdStore = store.state.user.siteId;
        await store.dispatch(UserActionTypes.ACTION_LOGOUT);
        checkSite(siteIdStore)
      }
    });
    const checkSite = (siteId) => {
      if (siteId === siteEnum.XF1 || siteId === 1) {
        return router.push("/xf/login")
      } else if (siteId === "3" || siteId === 3) {
        return router.push("/th/login")
      } else if (siteId === siteEnum.IND || siteId === 5) {
        return router.push("/ind/login")
      } else if (siteId === siteEnum.DY2 || siteId === 6) {
        return router.push("/dy/login")
      } else if (siteId === siteEnum.LH1 || siteId === 7) {
        return router.push("/lh/login")
      } else if (siteId === siteEnum.VNM || siteId === 8) {
        return router.push("/vi/login")
      } else if (siteId === siteEnum.KRW || siteId === 10) {
        return router.push("/kr/login")
      } else if (siteId === siteEnum.PAK || siteId === 11) {
        return router.push("/pak/login")
      } else if (siteId === siteEnum.PH2 || siteId === 37) {
        return router.push("/ph2/login")
      } else if (siteId === siteEnum.LK6 || siteId === 30) {
        return router.push("/lk6/login")
      } else {
        return location.reload();
      }
    }
    const i18nStoreLanguage = i18nStore();
    const { languageVal } = storeToRefs(i18nStoreLanguage);
    const { setLanguage } = i18nStoreLanguage;

    const handleLanguage = () => {
      // Clear existing language classes from <body> element
      document.body.classList.forEach((className) => {
        if (className.endsWith('lang')) {
          document.body.classList.remove(className);
        }
      });

      // Set the new language class on <body> element
      document.body.classList.add(languageVal.value + 'lang');
      setLanguage(languageVal.value);
    }
    const changePassword = async (formObj) => {
      formObj.affId = store.state.user.id;
      formObj.siteId = store.state.user.siteId;
      await store.dispatch(UserActionTypes.ACTION_UPDATE_LOGIN, formObj);
    };
    return {
      sidebar,
      device,
      avatar,
      name,
      languageVal,
      handleLanguage,
      ...toRefs(state),
      changePassword,
      siteId,
      siteEnum,
      isZhOnlySite
    };
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    padding: 0 15px;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .logo-container {
    float: left;
    height: 100%;
    width: auto;
    margin-left: 2em;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img.logo {
      height: 40px;
      width: auto;
    }

  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 5px 20px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        cursor: pointer;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        padding: 5px 12px;
        gap: 8px;

        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 25px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }

    .lang-container {
      width: 100px;
      position: relative;
    }

    .logout-btn-container {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  &.zh-only-site {
    @media (max-width: 992px) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      padding: 0 12px 0 128px;

      .logo-container {
        float: none;
        margin-left: 0;
        flex-shrink: 0;

        img.logo {
          height: 36px;
        }
      }

      .right-menu {
        float: none;
        padding: 0;
        flex-shrink: 0;

        .avatar-container {
          display: none;
        }

        .logout-btn-container {
          width: 32px;
          height: 32px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.navbar {

  .lang-container,
  .avatar-container,
  .logout-btn-container {
    background: #F3F8FC;
    border-radius: 10px;
  }
}

.lang-container {
  .el-input__inner {
    background: none;
    border: none;
  }
}
</style>
